import React from 'react';
import { BrioModal, BrioModalBody, BrioButton } from '../../components/BrioComponents';
import { ListPlus, Search, FilePlus2 } from 'lucide-react';

// First step of "Add line": choose what KIND of BOQ line to add. Each option
// routes to its existing modal. Spelling the choices out (with a line of
// context each) is the point — it makes the SD sub-trade path as discoverable
// as the tender-library search, which previously lived behind a separate
// button.
const OPTIONS = [
  {
    key: 'subtrade',
    Icon: ListPlus,
    title: 'Standard sub-trade',
    desc: 'Pick a canonical sub-trade and enter an allowance. Best for SD / early-stage — fills in the unit for you.',
  },
  {
    key: 'library',
    Icon: Search,
    title: 'Library item',
    desc: 'Search the priced item library (DD / tender) and add a measured line.',
  },
  {
    key: 'lump',
    Icon: FilePlus2,
    title: 'Provisional / PC / Dayworks',
    desc: 'A flagged lump sum with a free-text description — kept separate from measured works.',
  },
];

function AddLineChooserModal({ onClose, onSelect }) {
  const footer = <BrioButton variant="secondary" onClick={onClose}>Cancel</BrioButton>;
  return (
    <BrioModal title="Add a BOQ line" onClose={onClose} width="md" footer={footer}>
      <BrioModalBody>
        <div style={{ fontSize: '0.85rem', color: 'var(--brio-text-muted)', marginBottom: '0.9rem' }}>
          What kind of line do you want to add?
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
          {OPTIONS.map(({ key, Icon, title, desc }) => (
            <button
              key={key}
              type="button"
              onClick={() => onSelect(key)}
              className="brio-linechoice"
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '0.75rem', textAlign: 'left',
                padding: '0.85rem 1rem', borderRadius: 8, cursor: 'pointer', width: '100%',
                border: '1px solid var(--brio-border, #ddd)', background: 'var(--brio-surface, #fff)',
                font: 'inherit', color: 'inherit',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--brio-gold, #9F902A)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'var(--brio-border, #ddd)'; }}
            >
              <span style={{ color: 'var(--brio-gold, #9F902A)', marginTop: 2, flexShrink: 0 }}>
                <Icon size={18} />
              </span>
              <span>
                <span style={{ display: 'block', fontWeight: 600, marginBottom: '0.15rem' }}>{title}</span>
                <span style={{ display: 'block', fontSize: '0.82rem', color: 'var(--brio-text-muted)' }}>{desc}</span>
              </span>
            </button>
          ))}
        </div>
      </BrioModalBody>
    </BrioModal>
  );
}

export default AddLineChooserModal;
